<template>
  <div>
    <Dialog
      :header="$t('contacto.titulo.altaContacto')"
      :modal="true"
      :visible.sync="displayModal"
      :contentStyle="{ overflow: 'visible' }"
      @hide="closeDialog"
    >
      <Errors v-show="this.errors.length > 0" :errors="this.errors" />

      <div v-if="this.tipoContacto === 'email'">
        <div class="p-field">
          <label for="email"
            ><b>{{ $t("contacto.email.email") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-envelope"></i>
            </span>
            <InputText
              class="input"
              id="email"
              type="text"
              v-model="contacto.contactoEmail.email"
              :placeholder="$t('contacto.placeHolders.email.email')"
            />
          </div>
          <p
            class="text"
            v-tooltip.bottom="
              $t('contacto.notificaciones.tooltipCheckboxEmail')
            "
          >
            <Checkbox v-model="contacto.activo" :binary="true" />{{
              $t("contacto.notificaciones.checkboxEmail")
            }}
          </p>
        </div>
      </div>
      <Dialog
        :header="$t('contacto.email.activo.titulo')"
        :modal="true"
        :visible.sync="displayModificarEmailActivoModal"
        :contentStyle="{ overflow: 'visible' }"
        @hide="!displayModificarEmailActivoModal"
      >
        <div class="p-field">
          <Errors v-show="this.errors.length > 0" :errors="this.errors" />
          <p class="text">{{ $t("contacto.email.activo.descripcion") }}</p>
        </div>
        <template #footer>
          <div class="display-inline-flex">
            <Button
              @click.prevent="modificarEmailActivo(contacto)"
              :label="$t('common.buttons.confirm')"
              class=""
              icon="pi pi-save"
              iconPos="left"
            />
            <Button
              @click.prevent="
                errors.length == 0
                  ? altaEmail(contacto)
                  : closeEditarEmailUsuarioDialog()
              "
              :label="$t('common.buttons.cancel')"
              class="p-button-secondary"
              icon="pi pi-times"
              iconPos="left"
            />
          </div>
        </template>
      </Dialog>

      <div v-if="this.tipoContacto === 'telefono'">
        <div class="p-field">
          <label for="telefono"
            ><b>{{ $t("contacto.telefono.telefono") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-mobile"></i>
            </span>
            <InputText
              class="input"
              id="telefono"
              type="text"
              v-model="contacto.contactoTelefono.telefono"
              :placeholder="$t('contacto.placeHolders.telefono.telefono')"
            />
          </div>
          <p
            class="text"
            v-tooltip.bottom="
              $t('contacto.notificaciones.tooltipCheckboxPhone')
            "
          >
            <Checkbox v-model="contacto.activo" :binary="true" />{{
              $t("contacto.notificaciones.checkboxPhone")
            }}
          </p>
        </div>
      </div>

      <div v-if="this.tipoContacto === 'direccion'">
        <div class="p-grid p-fluid p-formgrid">
          <CTIAddress
            ref="ctiAddress"
            :required="true"
            @address:input="loadingCTIAddressNormalization = $event"
          />
          <div class="p-col-12 p-md-12 p-field">
            <p
              class="text"
              v-tooltip.bottom="
                $t('contacto.notificaciones.tooltipCheckboxAddress')
              "
            >
              <Checkbox v-model="contacto.activo" :binary="true" />{{
                $t("contacto.notificaciones.checkboxAddress")
              }}
            </p>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          @click.prevent="altaContacto(contacto)"
          :label="$t('common.buttons.save')"
          class=""
          icon="pi pi-save"
          iconPos="left"
          :disabled="loadingCTIAddressNormalization"
        />
        <Button
          @click.prevent="closeDialog()"
          :label="$t('common.buttons.cancel')"
          class="p-button-secondary"
          icon="pi pi-times"
          iconPos="left"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Errors from "@/components/utilidades/Errors.vue";

import {
  ALTA_CONTACTO_EMAIL,
  ALTA_CONTACTO_TELEFONO,
  ALTA_CONTACTO_DIRECCION,
} from "@/graphQLQueries/ContactoQueries";
import { CAMBIAR_EMAIL_USUARIO } from "@/graphQLQueries/UsuarioQueries";
import CTIAddress from "@/components/portal-cliente/Utils/CTIAddress";

export default {
  name: "AltaContacto",
  props: ["id", "propietario", "tipoContacto", "displayDialog"],
  components: {
    Errors,
    CTIAddress,
  },
  data() {
    return {
      contacto: {},
      displayModal: this.displayDialog,
      displayModificarEmailActivoModal: false,
      dropdownTiposVia: [],
      dropdownPaises: [],
      dropdownProvincias: [],
      errors: [],
      loadingCTIAddressNormalization: false,
    };
  },
  created() {
    this.crearContacto();
    this.getListadoTiposVia();
    this.getListadoPaises();
  },
  methods: {
    crearContacto() {
      if (this.tipoContacto === "email") {
        this.contacto = { contactoEmail: { email: null } };
      } else if (this.tipoContacto === "telefono") {
        this.contacto = { contactoTelefono: { telefono: null } };
      } else if (this.tipoContacto === "direccion") {
        this.contacto = {
          contactoDireccion: {
            tipoDireccion: "",
            direccion: "",
            codigoPostal: "",
            localidad: "",
            provincia: "",
            pais: "ES",
          },
        };
      }
    },
    altaContacto(contacto) {
      if (this.tipoContacto === "email") {
        if (contacto.activo) {
          this.displayModificarEmailActivoModal = true;
          return;
        }
        this.altaEmail(contacto);
      } else if (this.tipoContacto === "telefono") {
        this.altaTelefono(contacto);
      } else if (this.tipoContacto === "direccion") {
        this.altaDireccion(contacto);
      }
    },
    createTelefonoRequest(contacto) {
      return {
        idPropietario: this.id,
        tipoPropietario: this.propietario,
        contactoTelefono: { telefono: contacto.contactoTelefono.telefono },
        activo: contacto.activo,
      };
    },
    createEmailRequest(contacto) {
      return {
        idPropietario: this.id,
        tipoPropietario: this.propietario,
        contactoEmail: { email: contacto.contactoEmail.email },
        activo: contacto.activo,
      };
    },
    createDireccionRequest(contacto) {
      const ctiAddress = this.$refs.ctiAddress.getData();
      return {
        idPropietario: this.id,
        tipoPropietario: this.propietario,
        contactoDireccion: {
          tipoDireccion: ctiAddress.typeOfRoad,
          direccion: ctiAddress.address,
          codigoPostal: ctiAddress.postalCode,
          localidad: ctiAddress.location,
          provincia: ctiAddress.province,
          pais: "ES",
        },
        activo: contacto.activo,
      };
    },
    altaTelefono(contacto) {
      this.$apollo
        .mutate({
          mutation: ALTA_CONTACTO_TELEFONO,
          variables: {
            altaTelefonoRequest: this.createTelefonoRequest(contacto),
          },
        })
        .then(() => {
          this.closeDialog();
        })
        .catch((exception) => {
          this.errors = [];
          exception.graphQLErrors.forEach((error) => {
            this.errors.push(this.$i18n.t("contacto.errores." + error.message));
          });
        });
    },
    altaEmail(contacto) {
      if (this.validEmail(contacto.contactoEmail.email)) {
        this.$apollo
          .mutate({
            mutation: ALTA_CONTACTO_EMAIL,
            variables: {
              altaEmailRequest: this.createEmailRequest(contacto),
            },
          })
          .then(() => {
            this.closeEditarEmailUsuarioDialog();
          })
          .catch((exception) => {
            this.errors = [];
            exception.graphQLErrors.forEach((error) => {
              this.errors.push(
                this.$i18n.t("contacto.errores." + error.message)
              );
            });
          });
      } else {
        this.errors.push("El correo electrónico debe ser válido.");
      }
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    modificarEmailActivo(contacto) {
      this.$apollo
        .mutate({
          mutation: CAMBIAR_EMAIL_USUARIO,
          variables: {
            nuevoEmail: this.contacto.contactoEmail.email,
            idUsuario: this.id,
          },
        })
        .then(() => {
          this.altaEmail(contacto);
          this.errors = [];
        })
        .catch((exception) => {
          console.log(exception);
          this.errors = [];
          exception.graphQLErrors.forEach((error) => {
            this.errors.push(this.$i18n.t("contacto.errores." + error.message));
          });
        });
    },
    altaDireccion(contacto) {
      if (this.$refs.ctiAddress.valid()) {
        this.$apollo
          .mutate({
            mutation: ALTA_CONTACTO_DIRECCION,
            variables: {
              altaDireccionRequest: this.createDireccionRequest(contacto),
            },
          })
          .then(() => {
            this.closeDialog();
          })
          .catch((exception) => {
            this.errors = [];
            exception.graphQLErrors.forEach((error) => {
              this.errors.push(
                this.$i18n.t("contacto.errores." + error.message)
              );
            });
          });
      }
    },
    closeDialog() {
      this.displayModal = false;
      this.errors = [];
      this.$emit("close-dialog");
    },
    closeEditarEmailUsuarioDialog() {
      this.displayModificarEmailActivoModal = false;
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.display-inline-flex {
  display: inline-flex;
}
.marginBottom {
  margin-bottom: 0.3cm;
  margin-top: 1cm;
}
.p-dialog-title {
  font-size: 30px;
  color: #668fcd;
  text-align: center;
}
</style>
